import { FC } from 'react';
import clsx from 'clsx';
import { ActivityIndicator } from '@kontentino/ui';

interface ChartPlaceholderProps {
  state: 'loading' | 'empty';
  message?: string;
  className?: string;
  dataCy?: string;
}

const ChartPlaceholder: FC<ChartPlaceholderProps> = ({
  state,
  message,
  className,
  dataCy = 'analytics-chart-placeholder',
}) => {
  return (
    <div
      className={clsx(
        'tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-grayscale-20 tw-p-4',
        className,
      )}
      data-cy={dataCy}
      data-state={state}
    >
      {state === 'loading' ? (
        <ActivityIndicator className="tw-text-grayscale-100" />
      ) : (
        <p className="tw-text-center tw-text-sm tw-text-grayscale-100">
          {message}
        </p>
      )}
    </div>
  );
};

export default ChartPlaceholder;
